/* eslint-disable jira/naming/disallow-filenames */
/** @jsx jsx */
// eslint-disable-next-line jira/filename-case
import React, { memo, useCallback, useMemo } from 'react';
import { jsx } from '@compiled/react';
import JiraSideNavPlacement from '@post-office-placement/jira-side-nav/placement';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { postOfficeJiraSideNavResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { PostOfficeProvider } from '@jira/post-office__post-office-provider/src/index.tsx';
import { PlacementFetchProvider } from '@jira/post-office__post-office-provider/src/placement-fetch-provider.tsx';
import killswitch from '@jira/platform__utils-feature-gates-killswitch/src/index.tsx';
import { usePlacementPreloadedData } from '@jira/post-office__post-office-provider-preload-placement/src/preload-placement.tsx';
import { Placement } from '@atlassian/post-office-placement';

const PLACEMENT_ID = 'jira-side-nav';

const SideNavPlacement = () => {
	const [preloadedInitialData, clearPreloadedInitialData] = usePlacementPreloadedData(
		postOfficeJiraSideNavResource,
	);

	const handleClearPreloadedData = useCallback(() => {
		clearPreloadedInitialData();
	}, [clearPreloadedInitialData]);

	const memoizedPlacementProps = useMemo(() => {
		return {
			handleClearPreloadedData,
			preloadedInitialData,
		};
	}, [handleClearPreloadedData, preloadedInitialData]);

	return (
		<Placement
			placementId={PLACEMENT_ID}
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
			PlacementComponent={JiraSideNavPlacement}
			placementProps={memoizedPlacementProps}
		/>
	);
};

const SideNavRecommendation = () => {
	return (
		<JSErrorBoundary
			id="sideNavRecommendation"
			packageName="side-nav-recommendation"
			teamName="post-office"
			fallback={() => <></>}
		>
			<PostOfficeProvider>
				<div data-testid="side-nav-recommendation.jira-side-nav">
					{fg('post_office_ssr_jira_side_nav_enabled') ? (
						<PlacementFetchProvider resource={postOfficeJiraSideNavResource}>
							<SideNavPlacement />
						</PlacementFetchProvider>
					) : (
						<SideNavPlacement />
					)}
				</div>
			</PostOfficeProvider>
		</JSErrorBoundary>
	);
};

export const Nav4JiraSideNavRecommendation: React.MemoExoticComponent<() => JSX.Element | null> =
	memo((): JSX.Element | null => {
		if (!killswitch('killswitch_post_office_in_jira')) {
			return <SideNavRecommendation />;
		}

		return null;
	});

export const JswSideNavRecommendation: React.MemoExoticComponent<() => JSX.Element | null> = memo(
	(): JSX.Element | null => {
		if (!killswitch('killswitch_post_office_in_jira')) {
			return <SideNavRecommendation />;
		}

		return null;
	},
);
